import React, { useState, useEffect } from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { Table, Input } from "reactstrap";
import PropTypes from "prop-types";
import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber";

import style from "./Grid.module.scss";
import CircularProgress from "../../../CircularProgress/CircularProgress";
import LaddaButton, { EXPAND_LEFT } from "react-ladda";
import { initializeForm, preCheckForm, RecurringCommissionType } from "../types";
import { showToast } from "../../../../utils/Helper";
import { EXPAND_RIGHT } from "react-ladda/dist/constants";
import { NumberFormatInput } from "../../../NumberFormatInput/NumberFormatInput";

const AccountsGrid = ({ accounts, handleChange, disabled, fetchs, commission, status }) => {
  const [booking, setBooking] = useState([]);
  const [bookAccounts, setBookAccounts] = useState([]);

  useEffect(() => {
    if (accounts) {
      var book = booking;
      accounts.forEach((a) => {
        book[a.AccountId] = { loading: false, booked: false };
      });
      // setBookAccounts({bookAccounts: book});
      setBooking({ booking: book });
    }
  }, [accounts]);

  const bookGrid = (book, accountId) => {
    const body = {
      k2btrnmode: "UPD",
      recurringcommissionsdt: { ...commission, Accounts: accounts },
    };

    const newErrors = preCheckForm({ ...commission });
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setBooking({ ...booking, [accountId]: { loading: true, booked: false } });

    fetchs.updateRecurringCommission(body, (res) => afterSave(res, book, accountId));
  };

  const afterSave = (res, book, accountId) => {
    if (res && res.result && res.result.Code === 200) {
      fetchs.bookRecRecurringCommission(
        { id: commission.RecurringCommissionId, accountId: accountId },
        (res2) => {
          setBooking({ ...booking, [accountId]: { loading: false, booked: true } });
          // setBookAccounts({...bookAccounts, [accountId]: true});
          if (res2 && res2.result && res2.result.Code === 200) {
            //toggle(undefined, true);
            showToast("Recurring Commission Booked!");
          } else {
            showToast(res2 && res2.result ? res2.result.Description : "Server Error", true);
          }
        }
      );
    } else {
      showToast(res && res.result ? res.result.Description : "Server Error", true);
    }
  };

  const renderTable = () => {
    if (!accounts || accounts.length === 0) {
      return <EmptyTable loading={!accounts} />;
    }
    return (
      <React.Fragment>
        {accounts.map((a, index) => (
          <tr key={a.AccountId}>
            <td>{`${a.AccountNumber.trim()}`}</td>
            <td>
              <FormattedNumber value={a.RecurringCommissionBuyingPower} dataTypeDecimalName="currency" />
            </td>
            <td>
                <FormattedNumber value={a.RecurringCommissionFee} dataTypeDecimalName="currency" />
            </td>
            <td>
              <FormattedNumber value={a.RecurringCommissionBaseCalculation} dataTypeDecimalName="currency" />
            </td>
            <td>
              {disabled || a.RecurringCommissionAccountStatus == "Executed" ? (
                <FormattedNumber value={a.RecurringCommissionVolume || 0} dataTypeDecimalName="currency" />
              ) : (
                <NumberFormatInput
                  type="text"
                  customInput={Input}
                  disabled={booking[a.AccountId] && booking[a.AccountId].booked}
                  value={a.RecurringCommissionVolume}
                  onValueChange={(e) => handleChange(index, e.value)}
                  dataTypeDecimalName="currency"
                />
              )}
            </td>
            <td>
              <FormattedNumber value={a.RecurringCommissionTax} dataTypeDecimalName="currency" />
            </td>
            <td>
              <FormattedNumber value={a.RecurringCommissionTotal} dataTypeDecimalName="currency" />
            </td>
            {status !== "Executed" &&
              (a.RecurringCommissionAccountStatus == "Reverted" ||
                a.RecurringCommissionAccountStatus == "Initiated") && (
                <td style={{ alignSelf: "right", borderTop: "none" }}>
                  <LaddaButton
                    className="btn btn-ladda btn-warning"
                    loading={booking[a.AccountId] && booking[a.AccountId].loading}
                    disabled={booking[a.AccountId] && booking[a.AccountId].booked}
                    onClick={() => bookGrid(true, a.AccountId)}
                    data-style={EXPAND_RIGHT}
                  >
                    {booking[a.AccountId] && booking[a.AccountId].loading ? "Booking..." : "Book"}
                  </LaddaButton>
                </td>
              )}
          </tr>
        ))}
      </React.Fragment>
    );
  };

  return (
    <div style={{ minHeight: "auto", margin: 0 }} className={`content ${style.desk}`}>
      <Table className={style.table}>
        <thead>
          <tr>
            <th>Name</th>
            <th>Buying Power</th>
            <th>Fee %</th>
            <th>Base for calculation</th>
            <th>Commission</th>
            <th>Tax</th>
            <th>Total</th>
            <th></th>
          </tr>
        </thead>
        <tbody>{renderTable()}</tbody>
      </Table>
    </div>
  );
};

AccountsGrid.propTypes = {
  accounts: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

const EmptyTable = ({ loading }) => (
  <tr>
    <td colSpan="8" style={{ textAlign: "center", padding: "40px" }}>
      {loading ? (
        <CircularProgress style={{ marginTop: "10%" }} />
      ) : (
        <h4 style={{ textAlign: "center" }}>No Accounts</h4>
      )}
    </td>
  </tr>
);

EmptyTable.propTypes = {
  loading: PropTypes.bool.isRequired,
};

export default AccountsGrid;
